import Phaser from 'phaser'

/** Pure geometry helpers for procedural SHAPES TD silhouettes. */

export function regularPolygon(
  cx: number,
  cy: number,
  radius: number,
  sides: number,
  rotation = -Math.PI / 2
): Array<{ x: number; y: number }> {
  const pts: Array<{ x: number; y: number }> = []
  for (let i = 0; i < sides; i += 1) {
    const a = rotation + (i * Math.PI * 2) / sides
    pts.push({ x: cx + Math.cos(a) * radius, y: cy + Math.sin(a) * radius })
  }
  return pts
}

export function diamondPoints(cx: number, cy: number, rx: number, ry: number): Array<{ x: number; y: number }> {
  return [
    { x: cx, y: cy - ry },
    { x: cx + rx, y: cy },
    { x: cx, y: cy + ry },
    { x: cx - rx, y: cy }
  ]
}

export function trianglePoints(cx: number, cy: number, r: number): Array<{ x: number; y: number }> {
  return regularPolygon(cx, cy, r, 3, -Math.PI / 2)
}

export function strokePolygon(
  g: Phaser.GameObjects.Graphics,
  pts: Array<{ x: number; y: number }>,
  close = true
): void {
  if (pts.length === 0) return
  g.beginPath()
  g.moveTo(pts[0].x, pts[0].y)
  for (let i = 1; i < pts.length; i += 1) g.lineTo(pts[i].x, pts[i].y)
  if (close) g.closePath()
  g.strokePath()
}

export function fillPolygon(g: Phaser.GameObjects.Graphics, pts: Array<{ x: number; y: number }>): void {
  if (pts.length === 0) return
  g.beginPath()
  g.moveTo(pts[0].x, pts[0].y)
  for (let i = 1; i < pts.length; i += 1) g.lineTo(pts[i].x, pts[i].y)
  g.closePath()
  g.fillPath()
}
